export const HIDE_ICON_DELAY_MS = 150;
